import { ButtonT6, TabButtonGroup } from "Components/Common/Button/index";
import React, { Fragment } from "react";

const TabButtonSection = (props) => {
  const { handleOnClickSelectedTab, selectedTab } = props;
  return (
    <Fragment>
      <TabButtonGroup>
        <ButtonT6
          active={selectedTab === 1}
          onClick={() => {
            handleOnClickSelectedTab(1);
          }}
        >
          Upload Shipment Details
        </ButtonT6>
        <ButtonT6
          active={selectedTab === 2}
          onClick={() => {
            handleOnClickSelectedTab(2);
          }}
        >
          In Transit
        </ButtonT6>
        <ButtonT6
          active={selectedTab === 3}
          onClick={() => {
            handleOnClickSelectedTab(3);
          }}
        >
          Completed
        </ButtonT6>
        {/* <ButtonT6
          active={selectedTab === 4}
          onClick={() => {
            handleOnClickSelectedTab(4);
          }}
        >
          Domestic Tracking
        </ButtonT6> */}
      </TabButtonGroup>
    </Fragment>
  );
};

export default TabButtonSection;
